<template>
  <div
    v-if="isVisible"
    class="mt-8 flex flex-col items-center justify-start gap-y-4 rounded-md bg-white p-14 shadow-lg"
  >
    <div
      class="gap-4-2 flex w-full flex-col items-center justify-center sm:flex-row sm:justify-start sm:gap-x-2"
    >
      <Icon
        name="celebration"
        type="filled"
        size="text-3xl"
        class="text-primary"
      />
      <span class="flex w-full text-center text-2xl font-medium sm:text-3xl">
        {{ __('Your order has been placed successfully!') }}</span
      >
    </div>

    <div class="flex w-full text-center sm:justify-start">
      {{
        __(
          'The order status will be updated on the platform and you will receive an email once the package is shipped.'
        )
      }}
    </div>
    <div class="flex w-full items-center justify-center pt-6 sm:justify-end">
      <button @click="$emit('cancel')" class="animate-scale btn btn-fill">
        <span>{{ __('Back to shop') }}</span>
      </button>
    </div>
  </div>
</template>

<script setup>
  import { ref, watch } from 'vue';
  import Icon from '@/components/global/Icon.vue';

  const props = defineProps({
    show: {
      type: Boolean,
      default: false
    }
  });

  const isVisible = ref(false);

  watch(
    () => props.show,
    (newVal) => {
      if (newVal) {
        setTimeout(() => {
          isVisible.value = true;
        }, 50);
      } else {
        isVisible.value = false;
      }
    },
    { immediate: true }
  );
</script>
